/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import agGridHelper from "../../../shared/ag-grid-helper";
import ButtonIcon from "../../../shared/controls/ButtonIcon";
import useForm from "../../../shared/forms/useForm";
import moment from "moment";
import Filters from "../../../shared/forms/FormFilter/Filters";
import Field from "../../../shared/forms/Field";
import FormCalendarRange from "../../../shared/forms/FormFields/FormCalendarRange";
import Buttons from "../../../shared/forms/FormFilter/Buttons";
import FormFilter from "../../../shared/forms/FormFilter/FormFilter";
import FormMultiSelect from "../../../shared/forms/FormFields/FormMultiSelect";
import FormDropDown from "../../../shared/forms/FormFields/FormDropDown";
import useApiDieselCarga from "../../../api/taller/useApiDieselCarga";
import CargaCombustibleDetalle from "./CargaCombustibleDetalle";
import { VerIconRenderer } from "../../../shared/ag-grid-helper/GridRenderers";
import {
  AgCurrencyFormatter,
  AgNumberFormatter,
} from "../../../shared/ag-grid-helper/GridFormatters";
import FormTextBox from "../../../shared/forms/FormFields/FormTextBox";
import { v4 as uuidv4 } from "uuid";
import IconLibrary from "../../../shared/iconLibrary";
import constantes from "../../constantes";
import { useEmpresa } from "../../../layout/EmpresaProvider";
import { FormattedDate } from "react-intl";

const filtroInicial = {
  fecha: [moment().startOf("month")._d, moment().startOf("day")._d],
  rendimientoAsignado: null,
};

const rendimientoAsignadoOptions = [
  { id: true, nombre: "Asignado" },
  { id: false, nombre: "Sin asignar" },
];

const CargaCombustible = ({ soloLectura }) => {
  const api = useApiDieselCarga();
  const [datos, setDatos] = useState([]);
  const [cargaId, setCargaId] = useState(null);

  const {
    values: filter,
    onChange: onFilterChange,
    onClear,
  } = useForm(filtroInicial);

  const [exportGuid, setExportGuid] = useState(null);
  const fileInputRef = useRef(null);
  const { empresaId } = useEmpresa();

  useEffect(() => {
    if (exportGuid != null) {
      api.excel(filter).then();
    }
  }, [exportGuid]);

  const filtrar = async (filtro) => {
    const response = await api.filtrar(filtro);
    setDatos(response);
  };

  const onExport = async () => {
    setExportGuid(uuidv4());
  };

  const onUpload = async (event) => {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    await api.guardarCargasPorArchivo(formData);
    await filtrar(filter);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const DateCellRenderer = ({ value }) => (
    <div>
      <FormattedDate value={value} weekday="short" /> &nbsp;
      {moment(value).format("DD/MM/YYYY HH:mm:ss")}
    </div>
  );

  const ButtonsHeader = () => {
    return (
      <div className={"ag-grid header-icons"}>
        {constantes.empresa.SCF === empresaId && (
          <div
            className="image-upload"
            style={{ gridColumnEnd: "span 2", width: "fit-content" }}
          >
            <label htmlFor="cargas-file">
              <IconLibrary iconName="BsSearch" />
            </label>

            <input
              type="file"
              id="cargas-file"
              ref={fileInputRef}
              onChange={onUpload}
              accept=".xlsx,.xls"
            />
          </div>
        )}

        <ButtonIcon
          title={"Descargar"}
          iconName={"BiDownload"}
          onClick={onExport}
        />

        {!soloLectura && (
          <ButtonIcon
            title="Agregar"
            className={"grid-action"}
            iconName={"MdAddBox"}
            onClick={() => setCargaId(0)}
          />
        )}
      </div>
    );
  };

  return (
    <>
      <FormFilter
        columns={6}
        gridStyle={{ paddingTop: "0", marginTop: "0" }}
        filter={filter}
        onChange={onFilterChange}
        onClear={onClear}
        onFilter={(filtro) => filtrar(filtro)}
      >
        <Filters>
          <Field field="fecha" label="Fechas" render={FormCalendarRange} />

          <Field
            field="unidadIds"
            label="Numero económico"
            source="diesel/unidadesMotrizTransicion"
            render={FormMultiSelect}
          />

          <Field
            field="operadorIds"
            label="Operador"
            source="diesel/operadores"
            render={FormMultiSelect}
          />

          <Field
            field="proveedorIds"
            label="Proveedores"
            source="diesel/proveedoresExistentes"
            render={FormMultiSelect}
          />

          <Field
            field="unidadDeNegocioId"
            label="Unidad Negocio"
            source="unidadesNegocio"
            render={FormMultiSelect}
          />

          <Field
            field="coordinadorId"
            label="Coordinador"
            source="empleados"
            params={{
              puestoIds: [
                constantes.puestos.coordinadorTrafico,
                constantes.puestos.auxiliarTrafico,
              ],
              todasLasEmpresas: true,
            }}
            render={FormMultiSelect}
          />

          <Field
            field="tipoIds"
            label="Tipo"
            source="diesel/combustibles"
            render={FormMultiSelect}
          />

          <Field field="ticket" label="Ticket" render={FormTextBox} />

          <Field
            field="rendimientoAsignado"
            label="Rendimiento"
            render={FormDropDown}
            options={rendimientoAsignadoOptions}
          />
        </Filters>

        <Buttons filter={true} clear={true} style={{ top: "-50px" }} />
      </FormFilter>

      <div className="ag-theme-balham grid-principal">
        <AgGridReact
          rowSelection={"single"}
          enableSorting={true}
          enableFilter={true}
          pagination={true}
          frameworkComponents={{
            buttonsHeader: ButtonsHeader,
            verIconRenderer: VerIconRenderer,
            dateCellRenderer: DateCellRenderer,
          }}
          onGridReady={() => filtrar(filter).then()}
          rowData={datos}
          overlayLoadingTemplate={agGridHelper.loadingOverlay}
          defaultColDef={agGridHelper.defaultColumns}
          context={{
            onEdit: (id) => setCargaId(id),
          }}
          getRowClass={(params) => params.data.nombreColor}
        >
          <AgGridColumn
            field="folio"
            headerName="FOLIO"
            cellClass={"center"}
            minWidth={100}
          />

          <AgGridColumn
            field="combustible"
            headerName="TIPO"
            cellClass={"center"}
            minWidth={100}
          />

          <AgGridColumn
            field="ubicacion"
            headerName="UBICACIÓN"
            cellClass={"center"}
            minWidth={100}
          />

          <AgGridColumn
            field="fechaRegistro"
            headerName="FECHA REGISTRO"
            cellRenderer="dateCellRenderer"
            minWidth={150}
          />
          <AgGridColumn
            field="tiempoRegistroOperador"
            headerName="TIEMPO REGISTRO"
            cellClass={"center"}
            minWidth={150}
            valueFormatter={({ value }) => value || ""}
          />

          <AgGridColumn
            field="numeroEconomico"
            headerName="UNIDAD"
            headerClass={"center"}
            minWidth={100}
          />

          <AgGridColumn field="operador" headerName="OPERADOR" minWidth={300} />

          <AgGridColumn
            field="litros"
            headerName="LITROS"
            valueFormatter={AgNumberFormatter}
            minWidth={100}
          />

          <AgGridColumn
            field="precio"
            headerName="PRECIO"
            valueFormatter={AgCurrencyFormatter}
            precision={4}
            minWidth={100}
          />

          <AgGridColumn
            field="ticket"
            headerName="TICKET"
            cellClass={"center"}
            minWidth={100}
          />

          <AgGridColumn
            field="odometro"
            headerName="ODOMETRO"
            cellClass={"center"}
            minWidth={100}
          />

          <AgGridColumn
            field="proveedor"
            headerName="PROVEEDOR"
            minWidth={100}
          />

          <AgGridColumn
            field="controlador"
            headerName="CONTROLADOR"
            minWidth={100}
          />

          <AgGridColumn
            field="sello"
            headerName="SELLO"
            cellClass={"center"}
            minWidth={100}
          />

          <AgGridColumn
            field="rendimientoId"
            headerName="RENDIMIENTO"
            cellClass={"center"}
            minWidth={120}
            valueFormatter={({ value }) => value || ""}
          />

          <AgGridColumn
            maxWidth={160}
            headerName="VER"
            cellRenderer="verIconRenderer"
            pinned={"right"}
            cellClass={"left"}
            headerComponent="buttonsHeader"
          />
        </AgGridReact>
      </div>

      <CargaCombustibleDetalle
        cargaId={cargaId}
        onSaved={() => {
          filtrar(filter).then();
          setCargaId(null);
        }}
        onCancel={() => setCargaId(null)}
      />
    </>
  );
};

export default CargaCombustible;